module.exports = __webpack_public_path__ + "img/slika6.368de2bc.jpg";